export function checkResourceAccessByDivisions(permissionName, params = {}) {
    const { divisions = [], resourceDivisions = [] } = params;
    const resourceDivisionsArray = Array.isArray(resourceDivisions) ? resourceDivisions : [resourceDivisions];

    return divisions.some(
        ({ uuid, definedPermissions }) =>
            resourceDivisionsArray.includes(uuid) && definedPermissions.includes(permissionName)
    );
}
